import React, { useEffect, useCallback, useState } from 'react';

import { shuffle } from '../../utils/shuffle';
import { Button } from '../';
import { TaskContainer } from './Tasks';
import { MODES, MODE_SPECS, TASK_GROUP_TYPES } from '../../utils/constants';
import { Controls, Scenario } from './';

export const Round = ({
    changeTurn, 
    currentRoundIndex,
    disableTaskGroupSwap,
    game,
    goToNextRound,
    isLastRound,
    roundsCount,
    swapTaskGroup,
    setViewingFeedback,
    taskGroup,
    viewingFeedback,
    ...props }) => {
  

  const { taskCount, shuffleTasks } = MODE_SPECS[game.mode][currentRoundIndex];

  const [tasks, setTasks] = useState([]);
  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);

  // Scenario has an intro page; maybe theoretical future task groups could too
  const [showTaskGroupIntro, setShowTaskGroupIntro] = useState(taskGroup.$.type === TASK_GROUP_TYPES.SCENARIO);

  const screenText = game.screenText;

  const isLastTask = currentTaskIndex + 1 >= (taskCount ? taskCount * game.teams.length : tasks.length);


  // Set tasks (and shuffle if applicable)
  useEffect(() => {
    if (shuffleTasks) {

      const shuffledTasks = shuffle(taskGroup.TASK);
      setTasks(shuffledTasks);

    } else {

      setTasks(taskGroup.TASK);

    }
  }, [taskGroup.TASK, shuffleTasks])
  
  const goToNextTask = useCallback(() => {
    
    const nextTaskIndex = currentTaskIndex + 1;
    setViewingFeedback(false);

    if (isLastTask) {
      goToNextRound();
    } else {
      changeTurn();
      setCurrentTaskIndex(nextTaskIndex)
    }

  }, [changeTurn, currentTaskIndex, goToNextRound, isLastTask, setViewingFeedback])

  const swapTask = () => {
    // taskCount is per team
    if (tasks.length > taskCount * game.teams.length) {
      const newTasks = [...tasks];
      newTasks.splice(currentTaskIndex, 1);
      setTasks(newTasks);
    }
  } 


  const completeTask = (success) => {
    setViewingFeedback(true);
    props.completeTask(success)
  }
  
  if (!tasks || !tasks.length) {
    return '';
  }
  // Task
  return (
    <main className={`round round--${taskGroup.$.type.toLowerCase()}`}>

      <h1 className="sr-only">Questions</h1>

      {/* Background image */}
      {taskGroup.IMAGE ?
        <div className={`round__image ${showTaskGroupIntro ? '' : 'round__image--overlay'}`} role="img" aria-label={taskGroup.IMAGE[0].$.alt} style={{backgroundImage: `url(${process.env.PUBLIC_URL}/resources/tasks/images/${taskGroup.IMAGE[0].$.src})` }}></div>
      : "" }

      {/* Intro screen */}
      {showTaskGroupIntro ? 

        <div className="round__group-intro">

          <Controls swap={swapTaskGroup} disableSwap={disableTaskGroupSwap} />

          <Scenario scenario={taskGroup} />

          <Button variant="primary" onClick={() => setShowTaskGroupIntro(false)}>{screenText.global.next}</Button>

        </div>

      : 

        // Round trappings
        <div className="position-relative">

          {/* Buttons at the top */}
          <Controls 
            swap={swapTask} 
            disableSwap={tasks.length <= (taskCount * game.teams.length) || viewingFeedback} 
            hideSwap={taskGroup.$.type === TASK_GROUP_TYPES.SCENARIO || game.mode === MODES.LECTURE} 
          />

          <TaskContainer 
            task={tasks[currentTaskIndex]} 
            completeTask={completeTask} 
            goToNextTask={goToNextTask} 
            isLastTask={isLastTask}
            isLastRound={isLastRound}
            taskGroup={taskGroup} 
          />

        </div>
      }
    </main>
  )
}